<template>
    <Slide>
        <slot />
    </Slide>
</template>

<script setup>
// If you are using PurgeCSS, make sure to whitelist the carousel CSS classes
import { Slide } from 'vue3-carousel'
</script>
